/**
 * @generated SignedSource<<b00e715c0e94ea16c46b52dd1f1fc248>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type PreviewWidgetNoteIntegrationInput = {
  providerId?: string | null;
  size: WidgetNoteSize;
  storecastId?: string | null;
};
export type WANoteIntegrationPreviewQuery$variables = {
  input: PreviewWidgetNoteIntegrationInput;
  storecastId: string;
};
export type WANoteIntegrationPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetNoteIntegration: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
    }>;
  };
};
export type WANoteIntegrationPreviewQuery = {
  response: WANoteIntegrationPreviewQuery$data;
  variables: WANoteIntegrationPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WANoteIntegrationPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WidgetNote",
              "kind": "LinkedField",
              "name": "previewWidgetNoteIntegration",
              "plural": true,
              "selections": [
                (v4/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetNote_widgetNote"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WANoteIntegrationPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetNote",
            "kind": "LinkedField",
            "name": "previewWidgetNoteIntegration",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editingMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrgNote",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetNotePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": "largeImage",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "minHeight",
                                "value": 1080
                              },
                              {
                                "kind": "Literal",
                                "name": "minWidth",
                                "value": 1080
                              }
                            ],
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "size",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "height",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": "size(minHeight:1080,minWidth:1080)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "includedInSlideshow",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backgroundColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "version",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontStyle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageScale",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateX",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateY",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remoteImageURL",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "containImage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteSize",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea24a7da70570fbd0ce38e4727f0b373",
    "id": null,
    "metadata": {},
    "name": "WANoteIntegrationPreviewQuery",
    "operationKind": "query",
    "text": "query WANoteIntegrationPreviewQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetNoteIntegrationInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetNoteIntegration(input: $input) {\n      id\n      ...WidgetNote_widgetNote\n    }\n    id\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNote_widgetNote on WidgetNote {\n  id\n  note {\n    editingMode\n    isOrgNote\n    pages {\n      id\n    }\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e678ec07b432a528ab559d8e8f0c02e";

export default node;
